export default function formatRemoteFolder(response: Folder): Folder {
    const {folders = [], waypoints = [], routes = [], tracks = [], areas = []} = response;
    return {
        ...response,
        folders: folders.map((f) => ({
            ...f,
            type: 'folder',
        })),
        waypoints: waypoints.map((waypoint) => ({
            ...waypoint,
            type: 'waypoint',
        })),
        routes: routes.map((route) => ({
            ...route,
            type: 'track',
            track_type: 'route',
        })),
        tracks: tracks.map((track) => ({
            ...track,
            type: 'track',
            track_type: undefined,
        })),
        areas: areas.map((area) => ({
            ...area,
            type: 'area',
            track_type: 'polygon',
        })),
    };
}
